var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackPort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blob",
    x: -1112.519,
    y: -475.923,
    width: 2378.237,
    height: 1882.426,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 16,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Web_1920_Web_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_1920_Web_1",
    "data-name": "Web 1920 \\u2013 Web \\u2013 1",
    clipPath: "url(#clip-Web_1920_Web_1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#blob)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "blob-2",
    "data-name": "blob",
    d: "M1144.705,519c203.359,267.784,438.916,596.429,421.97,900.729s-284.7,581.822-537.207,662.157c-250.809,77.9-486.367-43.819-604.993-233.7C307.544,1658.3,307.544,1397.816,210.949,1086.213S-78.837,411.883-29.692,195.221C17.758-21.441,309.239-87.17,539.713-19.006S941.346,251.213,1144.705,519Z",
    transform: "matrix(-0.09, -1, 1, -0.09, -883.31, 1301.18)",
    fill: "#2979ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackPort);
export default __webpack_public_path__ + "static/media/backPort.a777260b.svg";
export { ForwardRef as ReactComponent };